import { useEffect, useState } from 'react';
import { useCurrentUser } from '../../../contexts/UserContext';
import { getStudentsForTeacher } from '../../../services/enrollmentService';

function getInitials(name) {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export default function StudentRoster() {
  const currentUser = useCurrentUser();
  const teacherId = currentUser?.id || currentUser?._id;
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (!teacherId) return undefined;
    setLoading(true);
    getStudentsForTeacher(teacherId)
      .then((data) => {
        if (cancelled) return;
        setStudents(data?.students || []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Unable to load students.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [teacherId]);

  return (
    <article className="info-card roster-card" aria-label="Student roster">
      <div className="info-card-header">
        <p className="eyebrow">Student Roster</p>
        {!loading && !error && (
          <span className="badge neutral">{students.length}</span>
        )}
      </div>

      {loading && <p className="muted-text">Loading students…</p>}
      {!loading && error && <p className="error-text">{error}</p>}
      {!loading && !error && students.length === 0 && (
        <p className="muted-text">No active students found.</p>
      )}

      {!loading && !error && students.length > 0 && (
        <ul className="roster-list">
          {students.map((student) => (
            <li key={student.id} className="roster-row">
              <div className="roster-avatar" aria-hidden="true">
                {getInitials(student.name)}
              </div>
              <div className="roster-info">
                <p className="info-title">{student.name}</p>
                <p className="muted-text">{student.tagline || student.email}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
